import {Action, handleActions} from 'redux-actions';
import {SET_QC_GENRES} from './GenresActions';
import {GenresState} from '../../../types';

export const initialState = {
    isLoading: true,
    genres: [],
};

export const setQcGenres = (state: GenresState, action: Action<any>) => {
    const genres = action.payload;
    return {
        genres,
        isLoading: false,
    };
};

const handlers = {
    [SET_QC_GENRES]: setQcGenres,
};

export default handleActions(handlers, initialState);
